import { ItemPage } from "./item";
import { Change } from "./change";
import { Quality } from "./quality.js";
import { MFR } from "./manufact";
import { MFRP } from "./manufactPart";
import { Resource } from "./resource";
import { Technology } from "./technology";
import { ProjectPage } from "./project";

import { UsersPage } from "./user";
import { UserGroupsPage } from "./userGroup";

export const ObjectPages = [
  ItemPage,
  Change,
  Quality,
  MFR,
  MFRP,
  Resource,
  Technology,
  ProjectPage,
  ...UsersPage,
  ...UserGroupsPage,
];
